import { render, staticRenderFns } from "./PlayerRegistration.vue?vue&type=template&id=f1813140&scoped=true&"
import script from "./PlayerRegistration.vue?vue&type=script&lang=js&"
export * from "./PlayerRegistration.vue?vue&type=script&lang=js&"
import style0 from "./PlayerRegistration.vue?vue&type=style&index=0&id=f1813140&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1813140",
  null
  
)

export default component.exports